import { Box } from '@mui/material';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import colors from '../../../../assets/theme/base/colors';

const severityItems = [
    { Icon: DisabledByDefaultOutlinedIcon, bg: colors.deviationSeverity.critical.bg,        iconColor: colors.deviationSeverity.critical.icon,        label: 'Critical',         description: 'Relative gap below -25%' },
    { Icon: WarningAmberOutlinedIcon,      bg: colors.deviationSeverity.high.bg,            iconColor: colors.deviationSeverity.high.icon,            label: 'High',             description: 'Relative gap -15% to -25%' },
    { Icon: InfoOutlinedIcon,              bg: colors.deviationSeverity.medium.bg,          iconColor: colors.deviationSeverity.medium.icon,          label: 'Medium',           description: 'Relative gap -5% to -15%' },
    { Icon: CheckCircleOutlinedIcon,       bg: colors.deviationSeverity.onTrack.bg,         iconColor: colors.deviationSeverity.onTrack.icon,         label: 'On Track',         description: 'Relative gap within 0% to -5%' },
    { Icon: TrendingUpIcon,                bg: colors.deviationSeverity.overRepresented.bg, iconColor: colors.deviationSeverity.overRepresented.icon, label: 'Over-represented', description: 'Relative gap above 0%' },
];

const varianceItems = [
    { sign: '−', bg: colors.deviationVariance.negative.bg, signColor: colors.deviationVariance.negative.sign, label: 'Under-representation' },
    { sign: '0', bg: colors.deviationVariance.neutral.bg,  signColor: colors.deviationVariance.neutral.sign,  label: 'On target' },
    { sign: '+', bg: colors.deviationVariance.positive.bg, signColor: colors.deviationVariance.positive.sign, label: 'Over-representation' },
];

const labelStyle = {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: colors.ui.secondaryText,
    textTransform: 'uppercase' as const,
    flexShrink: 0,
};

const itemRow = {
    display: 'flex',
    flexWrap: 'wrap' as const,
    alignItems: 'center',
    gap: 2,
};

const itemLabel = {
    fontSize: '0.8125rem',
    color: colors.dark.main,
};

export function PlanSummaryLegend() {
    return (
        <Box
            sx={{
                mt: 2,
                p: 2,
                backgroundColor: colors.white.main,
                borderRadius: '8px',
                border: `1px solid ${colors.ui.border}`,
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
            }}
        >
            <Box sx={itemRow}>
                <Box sx={labelStyle}>Severity:</Box>
                {severityItems.map(({ Icon, bg, iconColor, label, description }) => (
                    <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 22, height: 22, borderRadius: '4px', backgroundColor: bg, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Icon sx={{ width: 14, height: 14, color: iconColor }} />
                        </Box>
                        <Box component="span" sx={itemLabel}>{label} - {description}</Box>
                    </Box>
                ))}
            </Box>

            <Box sx={itemRow}>
                <Box sx={labelStyle}>Variance Status:</Box>
                {varianceItems.map(({ sign, bg, signColor, label }) => (
                    <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 22, height: 22, borderRadius: '4px', backgroundColor: bg, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Box component="span" sx={{ fontSize: '0.8125rem', fontWeight: 700, color: signColor, lineHeight: 1 }}>{sign}</Box>
                        </Box>
                        <Box component="span" sx={itemLabel}>{label}</Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
